<template>
<div class="pHeader">
  <el-row style="height: 75px;">
    <el-col :span="16" style="height: 75px;">
      <img style="height: 50%;margin: 17px 25px;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/logoblack.png">
    </el-col>
    <el-col :span="8" style="height: 75px;">
      <div class='menu' @click="showDeawer"></div>
    </el-col>
  </el-row>
  <el-drawer
  direction='ttb'
  :visible.sync="drawer"
  :with-header="false">
    <div>
      <el-row style="height: 75px;">
        <el-col :span="16" style="height: 75px;">
          <img style="height: 50%;margin: 25px 25px;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/logoblack.png">
        </el-col>
        <el-col :span="8" style="height: 75px;">
          <div class='el-dialog__close el-icon el-icon-close' style="float: right;margin: 30px 10px;font-size: 150%;" @click="closeDeawer"></div>
        </el-col>
      </el-row>
      <AsideBarItem :routerFun="router" :dataList="channels" :choseId="checkId" :activeNames="activeNames"></AsideBarItem>
      <div style="height: 50px;line-height: 50px;text-align: center;color: #7F7F7F;font-size: 18px;">
        <img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;    margin-bottom: 3px;" src="../../assets/fImage/电话.png">
        联系电话：0315-0088811
      </div>
    </div>
  </el-drawer>
</div>

</template>

<script>
	import {queryByPos,queryIndexByPos} from "../../api/front.js"
	import AsideBarItem from "../../components/p/AsideBarItem.vue"
	export default {
		name: "PHeader",
		components: {
			AsideBarItem,
			// Footer
		},
		props: {
			checkId: {
				type: String,
				require: '首页0'
			},
      activeNames:{
        type: String,
        default: () => '首页',
      }
		},
		data() {
			return {
        activeName:'1',
        drawer:false,
				channels: [{id:0,label:'首页'}],
				// checkId:0,
				mouseInId:null,
				mouseInItemId:null,
        screenWidth:(window.innerWidth)
			}
		},
		mounted() {
			queryIndexByPos('nav').then(data => {
				this.channels = this.channels.concat(this.filterNav(data.data))
				console.log("导航栏",this.channels)
			}).catch(error => {

			})
		},
		methods:{
			filterNav(list){
				// 隐藏律师相关导航：专业人员(26)及子项、专业文章(15)
				const liberalIds = [15,16,17,18,19,20]
				return (list || []).filter(it => it.id !== 26 && it.label !== '专业人员').map(it => {
					if (it.children && it.children.length) {
						it.children = it.children.filter(c => c.id !== 26 && c.label !== '专业人员' && !liberalIds.includes(c.id) && c.label !== '专业文章')
					}
					return it
				})
			},
		router(url){
			this.closeDeawer()
				this.$router.push(
					{
						path:url,
					}
				);
      },
      showDeawer(){
        this.drawer = true
      },
      closeDeawer(){
        this.drawer = false
      },
		} 
	}
</script>

<style>

</style>
<style lang="scss" scoped>
.pHeader ::v-deep .el-drawer__open .el-drawer.ttb{
  height: auto !important;
}
.coll-wrap ::v-deep .el-collapse-item__content {
    padding-bottom: 0 !important;
  }
  .coll-wrap ::v-deep .el-collapse-item__wrap {
    border: 0 !important;
  }
  .item{
    padding: 15px 0;
  }
.menu{
    float: right;
    margin: 30px 10px;
    width: 15%;
    min-width: 25px;
    height: 2px;
    border-top: 2px solid #000000;
    border-bottom: 2px solid #000000;
    padding: 5px 0;
    background-clip: content-box;
    background-color: #000000;
}
</style>
